import { BitfPaginationApiRequestPart } from '@bitf/core/api-call-state/bitf-pagination-api-request-part';

import {
  CampaignStatusApiCallStatePart,
  ChannelApiRequestPart,
  DateRangeApiRequestPart,
  TimeUnitApiRequestPart,
} from '@common/core/api-call-state';
import { DefaultApiCallStateMapper } from '@common/core/api-call-state';

import { EApiCallStateNames, EApiRequestPartKeys } from '@enums';
import { IBitfApiCallState } from '@interfaces';

export const apiCallStateConfig = [
  {
    apiCallStateName: EApiCallStateNames.DEMO,
    apiRequest: {
      // NOTE passing page and size from here is still valid if BitfPaginationApiRequestPart is not used
      // page: 1,
      // size: 2,
      sorting: [{ property: 'firstName', direction: 'ASC' }],
    },
    requestParts: [new BitfPaginationApiRequestPart(EApiRequestPartKeys.PAGINATION, { page: 1, size: 10 })],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.CAMPAIGNS,
    apiRequest: {
      // NOTE passing page and size from here is still valid if BitfPaginationApiRequestPart is not used
      // page: 1,
      // size: 2,
      sorting: [{ property: 'name', direction: 'ASC' }],
    },
    requestParts: [
      new BitfPaginationApiRequestPart(EApiRequestPartKeys.PAGINATION, { page: 1, size: 10 }),
      new CampaignStatusApiCallStatePart(),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.INSIGHTS_CHART,
    apiRequest: {
      // NOTE passing page and size from here is still valid if BitfPaginationApiRequestPart is not used
      // page: 1,
      // size: 2,
    },
    requestParts: [new DateRangeApiRequestPart(), new TimeUnitApiRequestPart(), new ChannelApiRequestPart()],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.INSIGHTS_CARDS,
    apiRequest: {
      // NOTE passing page and size from here is still valid if BitfPaginationApiRequestPart is not used
      // page: 1,
      // size: 2,
    },
    requestParts: [new DateRangeApiRequestPart(), new ChannelApiRequestPart()],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.INSIGHTS_CAMPAIGNS,
    apiRequest: {
      // NOTE passing page and size from here is still valid if BitfPaginationApiRequestPart is not used
      // page: 1,
      // size: 2,
      sorting: [{ property: 'name', direction: 'ASC' }],
    },
    requestParts: [
      new BitfPaginationApiRequestPart(EApiRequestPartKeys.PAGINATION, { page: 1, size: 5 }),
      new CampaignStatusApiCallStatePart(),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.INSIGHTS_CHART_CAMPAIGNS,
    apiRequest: {
      // NOTE passing page and size from here is still valid if BitfPaginationApiRequestPart is not used
      // page: 1,
      // size: 2,
    },
    requestParts: [new DateRangeApiRequestPart(), new TimeUnitApiRequestPart()],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
];
